import BaseController from './base_controller'

// Main Value Guidance controller: orchestrates lifecycle (after calculate, vessel added/removed,
// assumptions changed) so js.haml only dispatches events and this controller runs the steps.
export default class extends BaseController {
  connect() {
    this.element.addEventListener('value-guidance:afterCalculate', (e) => this.afterCalculate(e.detail))
    this.element.addEventListener('value-guidance:afterVesselAdded', (e) => this.afterVesselAdded(e.detail))
    this.element.addEventListener('value-guidance:afterAssumptionsChanged', (e) => this.afterAssumptionsChanged(e.detail || {}))
    this.element.addEventListener('value-guidance:vesselRemoved', (e) => this.afterVesselRemoved(e.detail))
  }

  afterCalculate(detail) {
    if (!detail?.imo) return
    this.element.dispatchEvent(new CustomEvent('value-guidance:syncCollapseStyles', { bubbles: true }))
    if (typeof startTooltips === 'function') startTooltips()
    const form = this.element.querySelector(`.vessel-form[data-imo="${detail.imo}"]`)
    if (form) form.dispatchEvent(new CustomEvent('value-guidance-form:disableSubmitAfterSubmit', { bubbles: true }))
    if (typeof highlightCustomResult === 'function') highlightCustomResult()
    const selector = `#calculator-forms-wrapper .vessel-form[data-imo="${detail.imo}"]`
    if (typeof startMarketValueModal === 'function') startMarketValueModal(selector)
    if (typeof startGaugePointer === 'function') startGaugePointer()
    if (typeof initCalcCharts === 'function') initCalcCharts(window.$ ? window.$(form) : null)
    if (typeof clearFormFeedback === 'function') clearFormFeedback()
    const formEl = this.element.querySelector(`.vessel-form[data-imo="${detail.imo}"]`)
    if (formEl) formEl.querySelectorAll('.calc-cell input').forEach((i) => i.classList.remove('double-border'))
  }

  afterVesselAdded(detail) {
    this.element.dispatchEvent(new CustomEvent('value-guidance:syncCollapseStyles', { bubbles: true }))
    if (detail?.assumptionDate && typeof dispatchFutureVesselCheck === 'function') dispatchFutureVesselCheck(detail.assumptionDate)
    if (typeof dispatchSyncCustomSectionVisibility === 'function') dispatchSyncCustomSectionVisibility()
    if (typeof disabledVesselCheck === 'function') disabledVesselCheck()
    if (typeof dispatchShowSpeedConsToggle === 'function') dispatchShowSpeedConsToggle()
    if (typeof startTooltips === 'function') startTooltips()
  }

  afterAssumptionsChanged(detail) {
    if (detail?.assumptionDate && typeof dispatchFutureVesselCheck === 'function') dispatchFutureVesselCheck(detail.assumptionDate)
    if (typeof disabledVesselCheck === 'function') disabledVesselCheck()
    if (typeof startTooltips === 'function') startTooltips()
  }

  afterVesselRemoved(detail) {
    if (!detail?.imo) return
    const form = this.element.querySelector(`form[data-imo="${detail.imo}"]`)
    if (form) form.remove()
    this.hideLoading()
  }
}
